import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class GetCrawledDataService {

  constructor(private http: HttpClient,
      private configService: ConfigService) { }
  
    getCrawledDataAPI =  "/api/getcddtalst";
    clientMasterOptionsAPI =  "/api/gtclntopts";
    crawledDataErrorsExcelAPI= "/api/genrtcrlddtxls";
  
    GetCrawledData(pagination: any) {
      return this.http.post(this.getCrawledDataAPI, pagination);
    }
  
    GetClientMasterOptions() {
      return this.http.post(this.clientMasterOptionsAPI, null);
    }
  
    GetCrawledDataToXLS(pagination: any) {
      const body={};
      return this.http.post(this.crawledDataErrorsExcelAPI,pagination,body);
    }
}
